import Vue from 'vue'
import {default as plugin, Bus, ModalsKeep} from './main.js'

Vue.use(plugin)

export default plugin

export {
  Bus,
  ModalsKeep
}
